import CoachesPage from '../CoachesPage';

const PastCoachList = () => {
  return <CoachesPage />;
};

export default PastCoachList;
